import api, { request } from '../../../../api';
import { IStore } from '../../../index';

export const deleteGroup = async (state: IStore, clubId: string | number, groupId: number) => {
  const response = await request.delete(`${api.admin.clubs}${clubId}/groups/${groupId}`);

  if (response.error) {
    return { errors: { groups: { msg: 'Error deleting the club group' } } };
  }

  return {
    adminGroups: {
      groups: state.adminGroups.groups.filter(group => group.id !== groupId)
    }
  };
};
